<footer>
  <div class="bg-white z-5">
    <div class="d-inline-flex text-center pt-5 pb-3">
        <div class="header">
            Built with ❤️ for travelers by travelers
        </div>
        <div class="sub-header">
            © 2025 Dollar Flight Club Inc. All Rights Reserved
        </div>
        <div class="footer-links">
            <a
              href="https://dollarflightclub.com/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
            <span class="separator">|</span>
            <a
              href="https://dollarflightclub.com/terms-of-use"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms of Use
            </a>
          </div>
    </div>
  </div>
</footer>
